<template>
  <div class="login">
    <div class="login_school_icon">
      <img alt="" src="../assets/imgs/loginSchoolIconNew.png" width="726">
    </div>
    <div v-if="title" class="login_systmeName">{{ title }}</div>
    <div class="login_form">
      <div class="login_form_title">登录</div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-position="left"
               label-width="94px">
        <el-form-item label="教育ID号：" prop="eduId">
          <el-input v-model="ruleForm.eduId" @keydown.native.space.prevent></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input v-model="ruleForm.password" type="password" @keydown.native.space.prevent></el-input>
        </el-form-item>
        <el-form-item class="validateCode" label="验证码：" prop="validateCode">
          <el-input v-model="ruleForm.validateCode" @keydown.native.space.prevent></el-input>
          <div v-if="imageVerifyUrl" class="codeImg" @click="getImgCode">
            <img :src="imageVerifyUrl" alt="" height="100%" width="100%">
          </div>
        </el-form-item>
        <el-form-item class="operate">
          <el-button :disabled="loginDisable" class="purple" type="primary" @click="submitForm('ruleForm')">登录
          </el-button>
          <el-button class="default" @click="register">注册</el-button>
        </el-form-item>

      </el-form>
      <div class="forgetPassword" @click="forgotPassword">忘记密码？</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Form, FormItem, Input, Message } from 'element-ui'
import { decryptWithSignature } from "@/util";

Vue.use(Form).use(FormItem).use(Input).use(Button)
export default {
  name: 'login',
  data () {
    const noSpaceValidator = (rule, value, callback) => {
      if (value && /\s/.test(value)) {
        callback(new Error('不允许包含空格'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        eduId: '',
        password: '',
        validateCode: ''
      },
      title: null,
      rules: {
        eduId: [{
          required: true,
          message: '请输入教育ID号',
          trigger: 'blur'
        }, {
          validator: noSpaceValidator,
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          validator: noSpaceValidator,
          trigger: 'blur'
        }],
        validateCode: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }, {
          validator: noSpaceValidator,
          trigger: 'blur'
        }]
      },
      imageVerifyToken: '',
      imageVerifyUrl: '',
      loginDisable: false
    }
  },
  methods: {
    submitForm (form) {
      const that = this
      this.$refs[form].validate((valid) => {
        if (valid) {
          that.loginDisable = true
          that.ruleForm.validateToken = that.imageVerifyToken
          that.$axios.post(window.baseURL + '/galaxy/baoming/api/v1/huaxia/applicant/login', that.ruleForm)
            .then(result => {
              const res = result.data
              const map = {

                VUE_APP_BATCHID_ART: '/art',

                VUE_APP_BATCHID_SCIENCE: '/science',

                VUE_APP_BATCHID_SPORT: '/sport'
              }
              const url = window.location.href
              const params = new URL(url).searchParams
              const batchId = params.get('batchId')
              if (result.code === '1000000' && res && JSON.stringify(res) !== '{}') {
                Message(
                  {
                    type: 'success',
                    message: '登录成功,即将跳转',
                    duration: 800,
                    onClose () {
                      that.$router.push(
                        {
                          path: map[decryptWithSignature(batchId)],
                          query: {
                            applicationId: res.applicationId || '',
                            applicantToken: res.applicantToken,
                            batchState: res.batchState,
                            fillEnable: res.fillEnable ? 1 : 0,
                            batchId
                          }
                        }
                      )
                    }
                  }
                )
              } else {
                that.getImgCode()
                that.loginDisable = false
              }
            })
            .catch(err => {
              console.log(err)
              that.loginDisable = false
            })
        }
      })
    },
    forgotPassword () {
      const url = window.location.href
      const params = new URL(url).searchParams
      const batchId = params.get('batchId')
      this.$router.push({
        path: "/forgotPassword",
        query: { batchId }
      });
    },
    register () {
      const url = window.location.href
      const params = new URL(url).searchParams
      const batchId = params.get('batchId')
      this.$router.push(
        {
          path: '/register',
          query: {
            batchId
          }
        }
      )
    },
    // 获取图形验证码
    getImgCode () {
      const url = window.location.href
      const params = new URL(url).searchParams
      const batchId = params.get('batchId')
      const map = {

        VUE_APP_BATCHID_ART: '2026年中招艺术特长生报名',

        VUE_APP_BATCHID_SCIENCE: '2026年中招科技特长生报名',

        VUE_APP_BATCHID_SPORT: '2026年中招体育特长生报名'
      }
      this.title = map[decryptWithSignature(batchId)]
      if (!batchId) {
        this.$router.replace({
          path: '/'
        })
        return
      }
      this.$axios.get(window.baseURL + `/galaxy/baoming/api/v1/huaxia/applicant/generateValidateCode`)
        .then(result => {
          const res = result.data
          if (result.code === '1000000' && res && JSON.stringify(res) !== '{}') {
            this.imageVerifyToken = res.imageVerifyToken
            this.imageVerifyUrl = res.url
          } else {
            this.imageVerifyToken = ''
            this.imageVerifyUrl = ''
          }
        })
    }
  },
  created () {
    this.getImgCode()
  }
}
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  background: #EDF3F7;
  padding-top: 4%;
  padding-bottom: 4%;
  overflow-y: auto;

  .login_school_icon {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .login_systmeName {
    text-align: center;
    color: #474747;
    font-size: 32px;
  }

  .login_form {
    width: 486px;
    margin: 50px auto 0;
    background-color: #fff;
    padding: 20px 36px;
    border-radius: 10px;

    .login_form_title {
      font-size: 24px;
      color: #353535;
      margin-bottom: 24px;
    }

    .forgetPassword {
      font-family: Microsoft YaHei UI;
      font-size: 12px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0px;
      text-align: left;
      color: rgba(24, 144, 255, 1);
      cursor: pointer;
    }

    .el-form-item__label {
      color: rgba(0, 0, 0, .85);
    }

    .el-input {
      height: 32px;
      line-height: 32px;

      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }

    .validateCode {
      .codeImg {
        float: right;
        width: 90px;
        height: 32px;
        background-color: rgba(226, 134, 148, 1);
        margin-top: 0px;
        cursor: pointer;
      }

      .el-input {
        float: left;
        width: 220px;

        .el-input__inner {
          width: 220px;
        }
      }
    }

    .operate {
      ::v-deep .el-form-item__content {
        margin-left: 0 !important;
      }

      .el-button {
        width: 198px;
      }

      .el-button + .el-button {
        margin-left: 16px;
      }
    }

    .purple {
      background-color: #1890FF !important;
      border-color: #1890FF !important;

      &:hover {
        background-color: #1890FF;
        border-color: #1890FF;
        color: #fff;
      }
    }

    .default:hover {
      background: #FFF;
      border: 1px solid #DCDFE6;
      color: #606266;
    }
  }
}

.tip {
  display: inline-block;
  margin-top: 12px;
  margin-left: 50%;
  transform: translate(-50%);
  align-items: center;
  text-align: center;

  div {
    font-size: 12px;
    color: #666666;
    display: block;
  }
}
</style>
